import * as React from 'react';

// Components
import { ResponsiveImage } from '@shopee-user/shared-customization-ui';

// Utils
import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';

// Assets
import imageMdpi from './assets/one-credential-icon-1x.png';
import imageHdpi from './assets/one-credential-icon-1.5x.png';
import imageXhdpi from './assets/one-credential-icon-2x.png';
import imageXxhdpi from './assets/one-credential-icon-3x.png';
import imageXxxhdpi from './assets/one-credential-icon-4x.png';

import imageRebrandMdpi from './assets/rebrand/one-credential-icon-1x.png';
import imageRebrandHdpi from './assets/rebrand/one-credential-icon-1.5x.png';
import imageRebrandXhdpi from './assets/rebrand/one-credential-icon-2x.png';
import imageRebrandXxhdpi from './assets/rebrand/one-credential-icon-3x.png';
import imageRebrandXxxhdpi from './assets/rebrand/one-credential-icon-4x.png';

type Props = { className?: string };

function OneCredentialMigrateSuccessImage({ className }: Props) {
  const { LOCALE } = config;
  const getSrcSet = () => {
    switch (LOCALE) {
      case Locale.ID:
      case Locale.SG:
      case Locale.VN:
      case Locale.TH:
      case Locale.PH:
        return [
          `${imageRebrandMdpi} 1x`,
          `${imageRebrandHdpi} 1.5x`,
          `${imageRebrandXhdpi} 2x`,
          `${imageRebrandXxhdpi} 3x`,
          `${imageRebrandXxxhdpi} 4x`,
        ].join(',');
      default:
        return [
          `${imageMdpi} 1x`,
          `${imageHdpi} 1.5x`,
          `${imageXhdpi} 2x`,
          `${imageXxhdpi} 3x`,
          `${imageXxxhdpi} 4x`,
        ].join(',');
    }
  };

  return (
    <ResponsiveImage
      className={className}
      defaultSrc={imageXhdpi}
      srcSet={getSrcSet()}
    />
  );
}

export default OneCredentialMigrateSuccessImage;
